import { i18next } from '@yola/ws-sdk';

export const emojis = {
  raisingHands: '&#x1f64c;',
};

export const labels = {
  raisingHand: () => i18next.t('Raising Hands'),
};
